import request from '@/utils/request'
export function getList() {
    return request({
      url: '/mt/count',
      method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/api/map_api.js